import { Chip, Stack } from '@mui/material';
import { Heading } from '@travelity/ui/heading';
import { ProductTypeIcon } from '@components/product-type-icon';
import { ProductType } from '@travelity/api/generated';

interface PackageBookingSideformHeadProps {
    type: ProductType;
    name: string;
    shared: boolean;
}

const PackageBookingSideformHead = ({
    type,
    name,
    shared,
}: PackageBookingSideformHeadProps) => {
    const typePrefix =
        type !== ProductType.DYNAMIC_PACKAGE
            ? shared
                ? 'Group'
                : 'Private'
            : '';

    return (
        <Stack
            direction="row"
            sx={{ pr: 1.5, pt: 1 }}
            alignItems="center"
            gap={1}
        >
            <Heading
                sx={{
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '20px',
                    pr: 1,
                }}
                ellipsis
            >
                {name}
            </Heading>
            <Chip
                sx={{
                    color: '#fff',
                    bgcolor: '#3B4D7D',
                    px: '12px',
                    py: '6px',
                    ml: 'auto',
                    textTransform: 'capitalize',
                    '& .MuiChip-label': {
                        pl: 0.5,
                        pr: 0,
                    },
                }}
                icon={<ProductTypeIcon type={type} shared={shared} />}
                label={`${typePrefix} ${type.split('_').join(' ')}`}
            />
            {/* {!!stops.length && ( */}
            {/*     <RouteTooltip stops={stops}> */}
            {/*         <Chip */}
            {/*             color="secondary" */}
            {/*             sx={{ */}
            {/*                 color: '#36869C', */}
            {/*                 bgcolor: '#DDF0F5', */}
            {/*                 px: '12px', */}
            {/*                 py: '6px', */}
            {/*                 '& .MuiChip-label': { */}
            {/*                     pl: 0.5, */}
            {/*                     pr: 0, */}
            {/*                 }, */}
            {/*                 '& .MuiChip-icon': { */}
            {/*                     mx: 0, */}
            {/*                 }, */}
            {/*             }} */}
            {/*             icon={ */}
            {/*                 <DirectionsRoundedIcon */}
            {/*                     sx={{ */}
            {/*                         fontSize: '12px', */}
            {/*                         color: '#36869C', */}
            {/*                     }} */}
            {/*                 /> */}
            {/*             } */}
            {/*             label={t('Route')} */}
            {/*         /> */}
            {/*     </RouteTooltip> */}
            {/* )} */}
        </Stack>
    );
};

export default PackageBookingSideformHead;
